import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SelectItem} from 'primeng/api';
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";

import {saveAs as importedSaveAs} from "file-saver";
import {PDFTemplateType} from "../enums/pdf-template-type.enum";
import {Transaction} from '../enums/txn-type.enum';
import {CommonTransformationService} from './common-transformation.service';
import {BLOB_RESPONSE_TYPE} from "../classes/common";
import {ImportTemplateSubtype} from "@app/solution-manager/data-import/data-import";
import {BillingLevelType} from "@app/shared";

@Injectable()
export class FileService {

  constructor(private http: HttpClient, private commonTransform: CommonTransformationService) {
  }

  showFileOnNewTab(data: any) {
    const dataType = data.headers.get('content-type');
    const blobData = new Blob([data.body], { type: dataType });

    let url = window.URL.createObjectURL(blobData);
    window.open(url);
  }

  saveFileToLocalStorage(fileName: string, data: any) {
    const dataType = data.headers.get('content-type');
    const blobData = new Blob([data.body], { type: dataType });

    importedSaveAs(blobData, fileName);
  }

  getPdfTemplatesForTxnType(txnType: Transaction, pdfTemplateType?: string): Observable<SelectItem[]> {
    let url = `/pdf/pdf-templates?transaction=${txnType}`;
    if (pdfTemplateType) {
      url += `&templateType=${pdfTemplateType}`;
    }
    return this.http.get<any>(url).pipe(map(res => {
      return this.commonTransform.convertToDropDown("name", res);
    }));
  }

  getDefaultPdfTemplateForTxnType(txnType: Transaction) {

    return this.getPdfTemplatesForTxnType(txnType).pipe(map(res => {
      return res.find(template => template.value.default);
    }));
  }

  getInvoiceSummaryReport(invoicePeriodId: number, billingLevelType: BillingLevelType): Observable<any> {
    let url = `/pdf/invoice/labor-invoice-summary?invoicePeriodId=${invoicePeriodId}&billingLevelType=${billingLevelType}`;
    return this.http.get(url, { observe: 'response', responseType: BLOB_RESPONSE_TYPE });
  }

  getActivityReport(startDate: string, endDate: string): Observable<any> {
    let url = `/pdf/labor-activity-report?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, { observe: 'response', responseType: BLOB_RESPONSE_TYPE });
  }

  getTxnInPDF(txnType: Transaction | number, refId: number, templateId?: number, pdfTemplateType?: PDFTemplateType): Observable<any> {
    let url = `/pdf?refId=${refId}&`;

    if (typeof txnType === "number") {
      url += `transactionId=${txnType}`;
    } else {
      url += `transaction=${txnType}`;
    }

    if (templateId) {
      url += `&templateId=${templateId}`;
    }

    if (pdfTemplateType) {
      url += `&templateType=${pdfTemplateType}`;
    }

    return this.http.get(url, { observe: 'response', responseType: BLOB_RESPONSE_TYPE });
  }

  getTxnInPDFThenShowOnNewTab(txnType: Transaction | number,  refId: number, templateId?: number, pdfTemplateType?: PDFTemplateType) {

    this.getTxnInPDF(txnType, refId, templateId, pdfTemplateType).subscribe(res => {
      this.showFileOnNewTab(res);
    });
  }

  getTxnInPDFThenSave(txnType: Transaction | number, refId: number, templateId?: number) {

    this.getTxnInPDF(txnType, refId, templateId).subscribe(res => {
      this.saveFileToLocalStorage(res.fileName, res);
    });
  }

  getImportTemplate(subtype: ImportTemplateSubtype): Observable<any> {
    const url = `/accounting/import-templates/download?subtype=${subtype}`;
    return this.http.get<any>(url, {observe: 'response', responseType: BLOB_RESPONSE_TYPE});
  }

  getImportTemplateThenSave(subtype: ImportTemplateSubtype) {
    this.getImportTemplate(subtype).subscribe(res => {
      this.saveFileToLocalStorage(res.filename, res);
    });
  }
}
